/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';
import { useIntl } from 'react-intl-next';

import { type Size } from '@atlaskit/icon';
import Tooltip from '@atlaskit/tooltip';

import { COMPONENT_TYPES } from './types';
import { IconBackground } from './styled';

const sizeStyles = cssMap({
	small: {
		width: '16px',
		height: '16px',
	},
	medium: {
		width: '24px',
		height: '24px',
	},
	large: {
		width: '32px',
		height: '32px',
	},
	xlarge: {
		width: '48px',
		height: '48px',
	},
});

type ResultIconProps = {
	type: string;
	size?: Size;
};

export const ResultIcon = ({ type, size = 'medium' }: ResultIconProps) => {
	const intl = useIntl();
	const componentType = COMPONENT_TYPES[type] ?? COMPONENT_TYPES.OTHER;
	const ComponentTypeIcon = componentType.icon;

	return (
		<Tooltip content={intl.formatMessage(componentType.message)}>
			<IconBackground color={componentType.color} size={size}>
				<ComponentTypeIcon aria-label={type} css={[sizeStyles[size]]} role="img" />
			</IconBackground>
		</Tooltip>
	);
};
